import { EMPTY_OBJECT } from '../../constants/common'
import {
  ARCHIVED_FILTER_NAME,
  ASSIGNEE_FILTER_NAME,
  DATE_RANGE_FILTER_WITH_OVERDUE_DATE,
  DUE_DATE_FILTER_NAME,
  HAS_CONTRACTORS_FILTER_NAME,
  STAFF_MEMBER_FILTER_NAME,
  STATUS_FILTER_NAME,
} from '../../constants/filter'
import { getDateRangeParam } from '../../utils/filter'

import { BIRDVIEW_OPEN_REQUEST_STATUSES } from './DashboardBirdview.constants.api'
import { checkIsBirdviewTeamScope } from './DashboardBirdview.utils'

// `staff_member` is the backend's own "my scope": owner, creator, assignee or
// responsible manager of the building (BR-DASH-11).
export function getBirdviewScopeFilters({ scope, userId }) {
  return checkIsBirdviewTeamScope(scope)
    ? EMPTY_OBJECT
    : { [STAFF_MEMBER_FILTER_NAME]: userId }
}

export function getBirdviewActiveRequestsFilters(params) {
  return {
    ...getBirdviewScopeFilters(params),
    [ARCHIVED_FILTER_NAME]: false,
  }
}

export function getBirdviewOpenRequestsFilters(params) {
  return {
    ...getBirdviewActiveRequestsFilters(params),
    [STATUS_FILTER_NAME]: BIRDVIEW_OPEN_REQUEST_STATUSES,
  }
}

export function getBirdviewOverdueRequestsFilters(params) {
  return {
    ...getBirdviewOpenRequestsFilters(params),
    [getDateRangeParam(DUE_DATE_FILTER_NAME)]: [
      DATE_RANGE_FILTER_WITH_OVERDUE_DATE,
    ],
  }
}

export function getBirdviewNoProviderRequestsFilters(params) {
  return {
    ...getBirdviewOpenRequestsFilters(params),
    [HAS_CONTRACTORS_FILTER_NAME]: false,
  }
}

export function getBirdviewUnassignedRequestsFilters(params) {
  return {
    ...getBirdviewOpenRequestsFilters(params),
    [ASSIGNEE_FILTER_NAME]: [null],
  }
}

export function getBirdviewBuildingsFilters(params) {
  return {
    ...getBirdviewScopeFilters(params),
    [ARCHIVED_FILTER_NAME]: false,
  }
}

export function toBirdviewListSection(data, toItem) {
  return { items: data.items.map(toItem), total: data.pagination.total }
}
